import { render, staticRenderFns } from "./modal-gerenciar-respostas.vue?vue&type=template&id=f318a49e&"
import script from "./modal-gerenciar-respostas.vue?vue&type=script&lang=js&"
export * from "./modal-gerenciar-respostas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f318a49e')) {
      api.createRecord('f318a49e', component.options)
    } else {
      api.reload('f318a49e', component.options)
    }
    module.hot.accept("./modal-gerenciar-respostas.vue?vue&type=template&id=f318a49e&", function () {
      api.rerender('f318a49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-gerenciar-respostas/modal-gerenciar-respostas.vue"
export default component.exports